import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { REPORTING_API_BASE_URL, ReportingTemplateRequest, ReportTemplate } from '@capital-access/reporting/common';

@Injectable()
export class TemplateService {
  private route: string = `${REPORTING_API_BASE_URL}templates`;
  constructor(private http: HttpClient) {}

  getTemplateDetailsById(id: number): Observable<ReportTemplate> {
    return this.http.get<ReportTemplate>(`${this.route}/${id}/get`);
  }

  editTemplate(id: number, payload: ReportingTemplateRequest) {
    return this.http.put<number>(`${this.route}/${id}/update`, payload);
  }

  deleteTemplate(id: number) {
    return this.http.delete(`${this.route}/${id}/delete`);
  }
}
